import styled, { css } from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';

interface IArticleCaptionAndCredits {
  credits?: string;
  caption?: string;
}

export const ArticleCaptionAndCredits = ({ caption, credits }: IArticleCaptionAndCredits) => (
  <ArticleCaptionAndCredits.Container $isCreditsOnly={!!(!caption && credits)}>
    {caption && (
      <ArticleCaptionAndCredits.Caption>{caption}&nbsp; &nbsp;</ArticleCaptionAndCredits.Caption>
    )}
    {credits && <ArticleCaptionAndCredits.Credits>{credits}</ArticleCaptionAndCredits.Credits>}
  </ArticleCaptionAndCredits.Container>
);

ArticleCaptionAndCredits.Container = styled.div<{ $isCreditsOnly: boolean }>`
  margin-top: 5px;
  max-width: 100%;
  width: 100%;
  padding: 5px 0;
  ${({ $isCreditsOnly }) =>
    $isCreditsOnly &&
    css`
      display: flex;
      justify-content: flex-end;
    `};
`;

ArticleCaptionAndCredits.Caption = styled.span`
  color: ${({ theme }) => theme.colors.darkGray3};
`;

ArticleCaptionAndCredits.Credits = styled.span`
  color: ${({ theme }) => theme.colors.darkGray4};
  ${variableFontRegular({ size: '11.5px', spacing: '0', height: '14px' })}
`;
